<template>
  <CatalogHeaderComponent />
  <div class="container-fluid">
    <div class="row g-0">
      <div class="d-none d-lg-block col-lg-2">
        <div class="accordion accordion-flush" id="accordionFlushExample">
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingOne">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                {{ $t("catalog.color") }}
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              class="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#accordionFlushExample"
            >
              <div class="accordion-body">
                <ul class="list-unstyled text-start">
                  <li
                    v-for="color in firstTenColors"
                    :key="color"
                    class="form-check"
                  >
                    <input
                      type="checkbox"
                      :value="color.color"
                      v-model="checked.color"
                      class="form-check-input"
                    />
                    <label
                      for="flexCheckDefault"
                      class="form-check-label"
                    ></label>
                    {{ $t("catalog.colors." + color.color) }}
                  </li>
                </ul>
                <ul
                  v-show="readMoreColor"
                  class="list-unstyled text-start"
                  id="more-colors"
                >
                  <li
                    v-for="color in remainingColors"
                    :key="color"
                    class="form-check"
                  >
                    <input
                      type="checkbox"
                      :value="color.color"
                      v-model="checked.color"
                      class="form-check-input"
                    />
                    <label
                      for="flexCheckDefault"
                      class="form-check-label"
                    ></label>
                    {{ $t("catalog.colors." + color.color) }}
                  </li>
                </ul>
                <button
                  class="btn btn-link"
                  @click="readMoreColor = !readMoreColor"
                >
                  <span v-if="!readMoreColor">
                    {{ $t("catalog.more") }}
                  </span>
                  <span v-else>
                    {{ $t("catalog.less") }}
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingTwo">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseTwo"
                aria-expanded="false"
                aria-controls="flush-collapseTwo"
              >
                {{ $t("catalog.length") }}
              </button>
            </h2>
            <div
              id="flush-collapseTwo"
              class="accordion-collapse collapse"
              aria-labelledby="flush-headingTwo"
              data-bs-parent="#accordionFlushExample"
            >
              <div class="accordion-body">
                <ul class="list-unstyled text-start">
                  <li
                    v-for="length in lengths"
                    :key="length.length"
                    class="form-check"
                  >
                    <input
                      type="checkbox"
                      :value="length.length"
                      v-model="checked.lengths"
                      class="form-check-input"
                    />
                    <label
                      for="flexCheckDefault"
                      class="form-check-label"
                    ></label>
                    {{ length.length }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingThree">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseThree"
                aria-expanded="false"
                aria-controls="flush-collapseThree"
              >
                {{ $t("catalog.vaselife") }}
              </button>
            </h2>
            <div
              id="flush-collapseThree"
              class="accordion-collapse collapse"
              aria-labelledby="flush-headingThree"
              data-bs-parent="#accordionFlushExample"
            >
              <div class="accordion-body">
                <div class="accordion-body">
                  <ul class="list-unstyled text-start">
                    <li
                      v-for="vaselife in firstTenVaselife"
                      :key="vaselife.vaselife"
                      class="form-check"
                    >
                      <input
                        type="checkbox"
                        :value="vaselife.vaselife"
                        v-model="checked.vaselife"
                        class="form-check-input"
                      />
                      <label
                        for="flexCheckDefault"
                        class="form-check-label"
                      ></label>
                      {{ vaselife.vaselife }}
                    </li>
                  </ul>
                  <ul
                    v-show="readMoreVaselives"
                    class="list-unstyled text-start"
                    id="more-vaselives"
                  >
                    <li
                      v-for="vaselife in remainingVaselife"
                      :key="vaselife.vaselife"
                      class="form-check"
                    >
                      <input
                        type="checkbox"
                        :value="vaselife.vaselife"
                        v-model="checked.vaselife"
                        class="form-check-input"
                      />
                      <label
                        for="flexCheckDefault"
                        class="form-check-label"
                      ></label>
                      {{ vaselife.vaselife }}
                    </li>
                  </ul>
                  <button
                    class="btn btn-link"
                    @click="readMoreVaselives = !readMoreVaselives"
                  >
                    <span v-if="!readMoreVaselives">
                      {{ $t("catalog.more") }}
                    </span>
                    <span v-else>
                      {{ $t("catalog.less") }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-10 col-12">
        <CategoryComponent />
      </div>
      <div class="container fixed-bottom d-lg-none d-block mb-3">
        <div class="row justify-content-end">
          <div class="col-3">
            <button
              type="button"
              class="btn"
              id="filter-button"
              data-bs-toggle="offcanvas"
              href="#offcanvas-filter"
              role="button"
              aria-controls="offcanvas-filter"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                fill="#4E4E4E"
                class="bi bi-funnel"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z"
                />
              </svg>
            </button>
            <div
              class="offcanvas offcanvas-bottom"
              id="offcanvas-filter"
              data-bs-scroll="true"
              data-bs-backdrop="true"
            >
              <div class="offcanvas-header">
                <button
                  type="button"
                  class="btn"
                  id="offcanvas-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="#4E4E4E"
                    class="bi bi-x-lg"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
                    />
                  </svg>
                </button>
              </div>
              <div class="offcanvas-body">
                <div
                  class="accordion accordion-flush"
                  id="accordionFlushExample"
                >
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOne"
                        aria-expanded="false"
                        aria-controls="flush-collapseOne"
                      >
                        {{ $t("catalog.color") }}
                      </button>
                    </h2>
                    <div
                      id="flush-collapseOne"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingOne"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        <ul class="list-unstyled text-start">
                          <li
                            v-for="color in firstTenColors"
                            :key="color.id"
                            class="form-check"
                          >
                            <input
                              type="checkbox"
                              :value="color.color"
                              v-model="checked.color"
                              class="form-check-input"
                            />
                            <label
                              for="flexCheckDefault"
                              class="form-check-label"
                            ></label>
                            {{ $t("catalog.colors." + color.color) }}
                          </li>
                        </ul>
                        <ul
                          v-show="readMoreColor"
                          class="list-unstyled text-start"
                          id="more-colors"
                        >
                          <li
                            v-for="color in remainingColors"
                            :key="color"
                            class="form-check"
                          >
                            <input
                              type="checkbox"
                              :value="color"
                              v-model="checked.color"
                              class="form-check-input"
                            />
                            <label
                              for="flexCheckDefault"
                              class="form-check-label"
                            ></label>
                            {{ $t("catalog.colors." + color.color) }}
                          </li>
                        </ul>
                        <button
                          class="btn btn-link"
                          @click="readMoreColor = !readMoreColor"
                        >
                          <span v-if="!readMoreColor">
                            {{ $t("catalog.more") }}
                          </span>
                          <span v-else>
                            {{ $t("catalog.less") }}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingTwo">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseTwo"
                        aria-expanded="false"
                        aria-controls="flush-collapseTwo"
                      >
                        {{ $t("catalog.length") }}
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingTwo"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        <ul class="list-unstyled text-start">
                          <li
                            v-for="length in lengths"
                            :key="length.length"
                            class="form-check"
                          >
                            <input
                              type="checkbox"
                              :value="length.length"
                              v-model="checked.lengths"
                              class="form-check-input"
                            />
                            <label
                              for="flexCheckDefault"
                              class="form-check-label"
                            ></label>
                            {{ length.length }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingThree">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseThree"
                        aria-expanded="false"
                        aria-controls="flush-collapseThree"
                      >
                        {{ $t("catalog.vaselife") }}
                      </button>
                    </h2>
                    <div
                      id="flush-collapseThree"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingThree"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        <div class="accordion-body">
                          <ul class="list-unstyled text-start">
                            <li
                              v-for="vaselife in firstTenVaselife"
                              :key="vaselife.vaselife"
                              class="form-check"
                            >
                              <input
                                type="checkbox"
                                :value="vaselife.vaselife"
                                v-model="checked.vaselife"
                                class="form-check-input"
                              />
                              <label
                                for="flexCheckDefault"
                                class="form-check-label"
                              ></label>
                              {{ vaselife.vaselife }}
                            </li>
                          </ul>
                          <ul
                            v-show="readMoreVaselives"
                            class="list-unstyled text-start"
                            id="more-vaselives"
                          >
                            <li
                              v-for="vaselife in remainingVaselife"
                              :key="vaselife.vaselife"
                              class="form-check"
                            >
                              <input
                                type="checkbox"
                                :value="vaselife.vaselife"
                                v-model="checked.vaselife"
                                class="form-check-input"
                              />
                              <label
                                for="flexCheckDefault"
                                class="form-check-label"
                              ></label>
                              {{ vaselife.vaselife }}
                            </li>
                          </ul>
                          <button
                            class="btn btn-link"
                            @click="readMoreVaselives = !readMoreVaselives"
                          >
                            <span v-if="!readMoreVaselives">
                              {{ $t("catalog.more") }}
                            </span>
                            <span v-else>
                              {{ $t("catalog.less") }}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CatalogHeaderComponent from "@/components/CatalogHeaderComponent.vue";
import CategoryComponent from "@/components/CategoryComponent.vue";
import allRosesArray from "../data/all-roses.json";
import allColorsRoses from "../data/all-colors.json";
import allVaselifeCategories from "../data/vaselifecategories.json";

export default {
  components: {
    CatalogHeaderComponent,
    CategoryComponent,
  },
  data() {
    return {
      allVaselife: allVaselifeCategories,
      allColors: allColorsRoses,
      allRoses: allRosesArray,
      firstTenColors: {},
      remainingColors: {},
      firstTenVaselife: {},
      remainingVaselife: {},
      checked: {
        color: [],
        lengths: [],
        vaselife: [],
      },
      lengths: [
        { length: 40 },
        { length: 50 },
        { length: 60 },
        { length: 70 },
        { length: 80 },
        { length: 90 },
        { length: 100 },
      ],
      readMoreColor: false,
      readMoreVaselives: false,
    };
  },
  methods: {
    available: function (data) {
      const dataSet = [];
      for (var i = 0; i < this.allRoses.length; i++) {
        dataSet.push(this.allRoses[i][data]);
      }
      const sortedDataSet = dataSet.filter(
        (item, index) => dataSet.indexOf(item) === index
      );
      return sortedDataSet;
    },
    getFirstTenColor() {
      this.firstTenColors = this.allColors.slice(0, 9);
    },
    getRemainingColors() {
      let length = this.allColors.length;
      this.remainingColors =  this.allColors.slice(9, length);
    },
    getFirstTenVaselife() {
      this.firstTenVaselife = this.allVaselife.slice(0, 9);
    },
    getRemainingVaselife() {
      let length = this.allColors.length;
      this.remainingVaselife =  this.allVaselife.slice(9, length);
    }
  },
  computed: {
    colorsFirstTen: function () {
      return this.available("color").sort().slice(0, 9);
    },
    colorsRemaining: function () {
      var length = this.available("color").length;
      return this.available("color")
        .sort()
        .slice(10, length - 1);
    },
    vaselifesFirstTen: function () {
      return this.available("vaselife").sort().slice(0, 9);
    },
    vaselifesRemaining: function () {
      var length = this.available("vaselife").length;
      return this.available("vaselife").sort().slice(10, length);
    }
  },
  provide() {
    return {
      checked: this.checked,
    };
  },
  mounted() {
    this.getFirstTenColor()
    this.getRemainingColors()
    this.getFirstTenVaselife()
    this.getRemainingVaselife();

  }
};
</script>

<style scoped>
#filter {
  margin-top: 14em;
}
.accordion-item {
  background: transparent !important;
}

.accordion-button {
  background: #87a8d959 !important;
  outline: none !important;
}

#accordionFlushExample {
  position: sticky !important;
  top: 14em !important;
  height: 70vh;
  overflow: auto;
}

#more-colors,
#more-vaselives
{
  margin-top: -1em;
}

#filter-button {
  box-shadow: 4px 4px 4px #c9c1bd, -4px -4px 4px rgba(255, 255, 255, 0.4);
  border-radius: 35px;
  padding: 0.5em;
}

#offcanvas-filter {
  background-color: #f1efef;
  background-image: url(data:image/png;base64,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) !important;
  height: 50vh !important;
}
</style>
